export default __webpack_public_path__ + "static/recognisable-light-e7edcce0dbd702f0c7918f4c5518d56d.png";